import { trackEvent, trackType } from '@/utils/trackUtils';
import { useDebounceEffect } from 'ahooks';
import dayjs from 'dayjs';
import { useEffect } from 'react';

export const useTrackBrowseEventWithCondition = (
  type: Array<trackType>,
  eventName: string,
  eventParam?: any,
  condition?: boolean[],
  deps?: any[]
) => {
  useDebounceEffect(
    () => {
      if (condition?.every(Boolean)) {
        trackEvent(type, `${eventName}_firstview`, eventParam);
      }
    },
    deps || [],
    { wait: 200 }
  );

  useEffect(() => {
    let startTime = 0;
    if (condition?.every(Boolean)) {
      startTime = dayjs().valueOf();
    }

    return () => {
      if (startTime !== 0) {
        const endTime = dayjs().valueOf();
        // 浏览时间，秒数
        const browserTime = endTime - startTime;

        // 大于等于1s的时间再进行数据上报
        if (browserTime >= 200) {
          trackEvent(type, eventName, {
            ...eventParam,
            browserTime: browserTime / 1000,
          });
        }
      }
    };
  }, deps);
};
